import React from "react";
import Navbar from "../Pages/Shared/Navbar/Navbar";
import { Outlet } from "react-router-dom";
import Footer from "../Pages/Shared/Footer/Footer";
import NavbarBelow from "../Pages/Shared/Navbar/NavbarBelow/NavbarBelow";

const Main = () => {
  return (
    <div>
      <Navbar></Navbar>
      <NavbarBelow></NavbarBelow>
      <Outlet></Outlet>
      <Footer></Footer>
    </div>
  );
};

export default Main;
